import { render } from "./DecorationScreen.vue?vue&type=template&id=caf4b50e&scoped=true"
import script from "./DecorationScreen.vue?vue&type=script&lang=js"
export * from "./DecorationScreen.vue?vue&type=script&lang=js"

import "./DecorationScreen.vue?vue&type=style&index=0&id=caf4b50e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf4b50e"]])

export default __exports__